import React from 'react'

const TickWhiteSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke="#FFF">
      <path fill="#FFF" fillRule="nonzero" strokeWidth=".5" d="M10.493 14.655L17.133 8l.888.888-7.528 7.528L7 12.923l.873-.888z" />
      <circle cx="12" cy="12" r="11.25" strokeWidth="1.5" />
    </g>
  </svg>
)

export default TickWhiteSmall
